/** Availability tiers for scrapyard used parts — maps to order acceptance SLA. */

export const AVAILABILITY_TIERS = [
  {
    value: 'CONFIRMED',
    label: 'Confirmed',
    desc: 'Part is physically in hand — can ship immediately',
    slaHours: 2,
    slaLabel: '2h order acceptance SLA',
  },
  {
    value: 'LIKELY',
    label: 'Likely',
    desc: 'Part is still on the vehicle — can be extracted within the acceptance SLA',
    slaHours: 4,
    slaLabel: '4h order acceptance SLA',
  },
  {
    value: 'BUYER_REQUESTED',
    label: 'Buyer-requested',
    desc: 'Extract on order only — you commit after the buyer places the order',
    slaHours: 6,
    slaLabel: '6h order acceptance SLA',
  },
];

export function tierLabel(value) {
  return AVAILABILITY_TIERS.find((t) => t.value === value)?.label || '—';
}

export function tierSlaLabel(value) {
  return AVAILABILITY_TIERS.find((t) => t.value === value)?.slaLabel || '';
}

export const TIER_LABELS = Object.fromEntries(
  AVAILABILITY_TIERS.map((t) => [t.value, t.label])
);
